import Container from '../../atoms/container/modalDescription';
import FlavourConfig from '../../../../shared/config/flavours';
import Text from '../../atoms/text/modalText';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';

function AnonymousModalDescription() {
  return (
    <Container>
      <Text>
        {TranslationManager.get(
          'MODAL.ANONYMOUS.DESCRIPTION_TOP',
          FlavourConfig.appTitle
        )}
      </Text>
      <Text>
        {TranslationManager.get('MODAL.ANONYMOUS.DESCRIPTION_BOTTOM')}
      </Text>
    </Container>
  );
}

export default AnonymousModalDescription;
